import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import type { MouseEventHandler } from 'react';
import { EColors, getColor } from 'theme';

type FieldClearIconButtonProps = {
    onClear: () => void;
    disabled?: boolean;
    ariaLabel?: string;
};

export function FieldClearIconButton({ onClear, disabled = false, ariaLabel = 'Clear' }: FieldClearIconButtonProps) {
    const handleMouseDown: MouseEventHandler = event => {
        event.preventDefault();
        event.stopPropagation();
    };

    const handleClick: MouseEventHandler = event => {
        event.stopPropagation();
        onClear();
    };

    return (
        <IconButton
            size="small"
            onMouseDown={handleMouseDown}
            onClick={handleClick}
            disabled={disabled}
            aria-label={ariaLabel}
            tabIndex={-1}
            sx={{
                color: getColor(EColors.pureBlack, 0.55),
                '& .MuiSvgIcon-root': {
                    fill: getColor(EColors.pureBlack, 0.55),
                },
                '&:hover': {
                    color: getColor(EColors.pureBlack, 0.85),
                    '& .MuiSvgIcon-root': {
                        fill: getColor(EColors.pureBlack, 0.85),
                    },
                },
            }}
        >
            <CloseIcon fontSize="small" />
        </IconButton>
    );
}
